import { useTranslation } from 'react-i18next';
import { useWhatsAppMediaUrl } from './useWhatsAppMediaUrl';
import type { WhatsAppMessage } from './whatsAppMessageTypes';

/**
 * WHATSAPP MEDIA AUDIO — il player di un audio WhatsApp, coi suoi tre stati:
 * caricamento, errore, riproduzione.
 *
 * Serve sia al file audio allegato ({@link WhatsAppMediaContent}) sia alla nota vocale
 * ({@link WhatsAppVoiceNote}), che è la stessa cosa più un tasto. L'hook che scarica il
 * binario era già condiviso, ma la resa dei suoi stati no: erano tre rami identici
 * scritti in due file, cioè la stessa divergenza futura che l'estrazione dell'hook
 * voleva evitare, spostata di un livello.
 */
interface WhatsAppMediaAudioProps {
  message: WhatsAppMessage;
}

export function WhatsAppMediaAudio({ message }: WhatsAppMediaAudioProps) {
  const { t } = useTranslation();
  const { url, failed } = useWhatsAppMediaUrl(message.whatsAppMessageId);

  if (failed) {
    return (
      <span className="wa-media wa-media--error">
        {t('whatsapp.media.error')}
      </span>
    );
  }

  if (!url) {
    return (
      <span className="wa-media wa-media--loading">
        {t('whatsapp.media.loading')}
      </span>
    );
  }

  return <audio className="wa-media wa-media--audio" src={url} controls />;
}
